import { render, staticRenderFns } from "./blockList.vue?vue&type=template&id=72992b30&"
import script from "./blockList.vue?vue&type=script&lang=js&"
export * from "./blockList.vue?vue&type=script&lang=js&"
import style0 from "./blockList.vue?vue&type=style&index=0&id=72992b30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports